<template>
    <div>
        <hr class="chat-hr" />
        <b-form-input
            v-model="form.message"
            placeholder="Saisissez votre message"
            @change="sendMessage"
        >
        </b-form-input>
    </div>
</template>

<script>
export default {
    name: 'CommentCreate',

    props: {
        point: {},
    },

    data() {
        return {
            form: {},
        }
    },

    methods: {
        async sendMessage() {
            this.form.pending_point_id = this.point.id
            try {
                await axios.post('/pendingPointComments', this.form)
                this.refreshComments()
            } catch (error) {
                console.log(error)
            }
        },

        refreshComments() {
            this.form.message = ''
            this.$parent.getComments()
        },
    },
}
</script>

<style scoped>
.chat-hr {
    margin-top: 5px;
    margin-bottom: 15px;
}
</style>
